// extracted by mini-css-extract-plugin
export var columnItem = "_dv-3";
export var columnItemDraggable = "_dv-4";
export var dragHandle = "_dv-0";
export var dragHandleHovered = "_dv-1";
export var dropdown = "_dv-5";
export var dropdownContent = "_dv-7";
export var dropdownInner = "_dv-6";
export var filterDropdownHeader = "_dv-8";
export var icon = "_dv-2";
export var sectionDivider = "_dv-9";